import React from 'react'
import '../css/TimeCard.scss'
import { isMobileOnly } from 'react-device-detect'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import FacebookIcon from './../svg/facebook.png';
import TwitterIcon from './../svg/twitter.png';

const TimeCard = ({ timeData, active, data, emptyClass }) => {
  // maybe use filter to create sorted industry-specific objects
  var encodedURI = encodeURIComponent(window.location.origin + window.location.pathname + window.location.hash)

  return <div className={`timeCard ${active ? 'active' : ''} ${timeData.aspect}-container`}>
    <div className={'timeCard__wrapper'}>
      <Container fluid={true}>
        <Row>
          <div className={`timeCard-image image-container ${emptyClass} ${isMobileOnly ? 'square ' + timeData.align : timeData.aspect}`}>
            <img src={`./img/${timeData.image ? timeData.industry_key + '/' + timeData.image : 'no_image/GE_ImageGraphics_transparent.png'}`} alt={timeData.headline} />
          </div>
        </Row>
      </Container>
      <div className={'card__description'}>
        <Container>
          <Row>
            <Col md={{ span: 7, offset: 4 }} lg={{ span: 5, offset: 6 }} >
              <div className='timeCard-text timeline-card-copy'>
                <div className='meta-title'>{data.industries[timeData.industry_key].title}</div>
                {timeData.body}
                {timeData.asterisk ? <div className='asterisk'><br />{timeData.asterisk}</div> : ''}
                <ul className='social_links'>
                  <li className='social_link'>
                    <a href={`https://www.facebook.com/sharer.php?u=${encodedURI}%2F%23%2Findustry%2F${timeData.industry_key}%2F${timeData.key}`} target='_blank' rel='noopener noreferrer'>
                      <img src={FacebookIcon} alt={'Go to Facebook'} />
                    </a>
                  </li>
                  <li className='social_link'>
                    <a href={`https://twitter.com/intent/tweet?url=${encodedURI}%2F%23%2Findustry%2F${timeData.industry_key}%2F${timeData.key}`} target='_blank' rel='noopener noreferrer'>
                      <img src={TwitterIcon} alt={'Go to Twitter'} />
                    </a>
                  </li>
                  {/* <li className='social_link linkedIn'><a href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodedURI}%2F%23%2Findustry%2F${timeData.industry_key}%2F${timeData.key}`} target='_blank' rel='noopener noreferrer'>linkedIn</a></li> */}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  </div>
}

export default TimeCard
